/* Managed Headset Program — the page's only script.
 *
 * Everything else on this page (FAQ accordion, coverage and full-kit
 * disclosures, form option pills, form success state) is native HTML
 * or Liquid and works with JavaScript disabled. This does two things:
 *
 *   1. Measures the theme's own sticky header so the anchor bar can sit
 *      below it instead of underneath it, and so anchor jumps clear both.
 *   2. Reveals the mobile sticky CTA once the hero — which already
 *      carries the same CTA — has scrolled out of view.
 *
 * Both degrade sensibly without JS: the CSS fallback offset keeps anchor
 * targets clear of the header, and the sticky CTA stays hidden.
 */
(function () {
  'use strict';

  /* The theme header's height is not knowable at build time — it changes
     with breakpoint and with whether the announcement bar is showing — so
     it is measured rather than hard-coded. */
  function syncOffsets() {
    var root = document.documentElement;
    var header = document.getElementById('shopify-section-header');
    var headerHeight = 0;

    if (header) {
      var inner = header.firstElementChild;
      var headerPos = window.getComputedStyle(header).position;
      var innerPos = inner ? window.getComputedStyle(inner).position : '';
      var isPinned = function (p) { return p === 'sticky' || p === 'fixed'; };

      // Only offset for a header that actually stays on screen.
      if (isPinned(headerPos) || isPinned(innerPos)) {
        // Cap it: a mis-measured header should never push content off-screen.
        headerHeight = Math.min(header.getBoundingClientRect().height, 200);
      }
    }

    var subnav = document.querySelector('.mhp-subnav--sticky');
    var subnavHeight = subnav ? subnav.getBoundingClientRect().height : 0;

    root.style.setProperty('--mhp-header-offset', headerHeight + 'px');
    root.style.setProperty('--mhp-scroll-offset', (headerHeight + subnavHeight + 12) + 'px');
  }

  function init() {
    syncOffsets();

    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(syncOffsets, 150);
    });

    var bar = document.querySelector('[data-mhp-sticky-cta]');
    if (!bar) return;

    var hero = document.getElementById('mhp-hero');

    // No hero to watch, or no IntersectionObserver: show the bar rather
    // than hide the CTA entirely. Failing open is the safer default.
    if (!hero || typeof IntersectionObserver === 'undefined') {
      bar.hidden = false;
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          bar.hidden = entries[i].isIntersecting;
        }
      },
      { rootMargin: '0px 0px -40% 0px' }
    );

    observer.observe(hero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
